module.exports = __webpack_public_path__ + "static/Medtronic-c7d1a49f973367b9a87b32d77ae04ce3.png";